import { useState } from 'react';
import { validateAuthTemplateForm } from '../utils/templateValidation';

export const useAuthTemplate = (formData, setValidationErrors) => {
  const [validationErrors] = useState({});

  const validateForm = () => {
    const errors = validateAuthTemplateForm(formData);
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  return {
    validationErrors,
    validateForm,
  };
};
